import { useModal } from "@/components/core/modals/use-modal.ts";
import { FileViewer } from "@/components/document-viewer/file-viewer.tsx";
import { useDocumentConfigMutation } from "@/features/dashboard/api/queries/document-config-queries.ts";
import type { Media } from "@/features/dashboard/types/media";
import { IconFile } from "@tabler/icons-react";
import { useRef } from "react";

type FileLinkProps = {
	file: Media;
	title?: string;
	mime_type: string;
	maxLength?: number;
} & { url: string };

export function FileLinkWithViewer({ file, maxLength = 30 }: FileLinkProps) {
	const modal = useModal();
	const documentTokenMutation = useDocumentConfigMutation();
	const lastClickTime = useRef<number>(0);

	const handleClick = async (file: Media) => {
		const now = Date.now();
		if (now - lastClickTime.current < 1000) {
			return; // Prevent clicks within 1 second
		}
		lastClickTime.current = now;
		const fileExtension = file.file_name.split(".").pop();
		let response = null;
		console.log(fileExtension);
		if (!["pdf", "octet-stream", "image/jpeg", "image/png", "png", "PNG", "jpeg", "video/mp4", "mp4"].includes(fileExtension)) {
			response = await documentTokenMutation.mutateAsync({
				file_type: fileExtension,
				title: file.name || file.file_name,
				url: file.original_url || file.url,
				mode: "view",
			});

			modal.openModal({
				title: "Default Modal",
				size: "full",
				showHeader: false,
				showFooter: false,
				component: <FileViewer attachment={file} token={response ? response?.token : null} options={response ? response?.options : null} />,
			});
		} else {
			modal.openModal({
				title: "Default Modal",
				size: "full",
				showHeader: false,
				showFooter: false,
				component: <FileViewer attachment={file} />,
			});
		}
	};

	/*const getFileIcon = (type: string): JSX.Element => {
		if (type.includes("pdf")) {
			return <IconFileTypePdf size={18} stroke={2} />;
		}
		if (["doc", "docx"].indexOf(type) >= 0) {
			return <IconFileTypeDoc size={18} stroke={2} />;
		}
		if (["png", "jpeg", "jpg"].indexOf(type) >= 0) {
			return <IconFileTypePng size={18} stroke={2} />;
		}
		return <IconFile size={18} stroke={2} />;
	};*/

	const getFileIcon = (type: string): JSX.Element => {
		if (type.includes("pdf")) {
			return <IconFile size={18} stroke={2} />;
		}
		if (["doc", "docx"].indexOf(type) >= 0) {
			return <IconFile size={18} stroke={2} />;
		}
		if (["png", "jpeg", "jpg"].indexOf(type) >= 0) {
			return <IconFile size={18} stroke={2} />;
		}
		return <IconFile size={18} stroke={2} />;
	};

	const truncateFileName = (fileName: string): string => {
		if (fileName.length > maxLength) {
			const extension = fileName.split(".").pop();
			const truncated = fileName.substring(0, maxLength - (extension?.length || 0) - 3);
			return `${truncated}...${extension}`;
		}
		return fileName;
	};

	const fileType = file?.mime_type || "";
	return (
		<button
			type="button"
			className="cursor-pointer inline-flex flex-row items-center gap-1 p-1 pr-2 w-auto rounded-md whitespace-nowrap bg-blue-50 hover:bg-blue-100"
			onClick={() => {
				handleClick(file);
			}}
		>
			<span className="inline-flex text-blue-600">{getFileIcon(fileType)}</span>
			<span className="text-sm font-semibold text-blue-600">{truncateFileName(file.file_name || file.name)}</span>
		</button>
	);
}
